import { render, staticRenderFns } from "./vault-filter-card.vue?vue&type=template&id=0a3eb26c&scoped=true"
import script from "./vault-filter-card.vue?vue&type=script&lang=js"
export * from "./vault-filter-card.vue?vue&type=script&lang=js"
import style0 from "./vault-filter-card.vue?vue&type=style&index=0&id=0a3eb26c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3eb26c",
  null
  
)

export default component.exports